import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationRu from './locales/ru/translation.json';
import translationPl from './locales/pl/translation.json';
import { appLanguage } from './services/appLanguage';

// Польский по умолчанию, русский — только явным REACT_APP_LANG=ru
// (правило в `services/appLanguage.ts`, не здесь).
const language = appLanguage();

i18n.use(initReactI18next).init({
  lng: language,
  fallbackLng: language,
  resources: {
    ru: {
      translation: translationRu,
    },
    pl: {
      translation: translationPl,
    },
  },
  interpolation: {
    // 🔴 ТЗ 0071: экранирование i18next выключено. Оно превращало `/` и `&` в
    // подставленных значениях в `&#x2F;` и `&amp;`, а React выводит строку как
    // текст — студент читал «CI&#x2F;CD» и «9&#x2F;15&#x2F;2026». React сам
    // экранирует любой текст; единственный путь HTML в разметку —
    // `dangerouslySetInnerHTML`, и туда результат `t()` не передаётся нигде
    // (проверено поиском; сторож — `src/__tests__/i18nEscaping.test.ts`).
    escapeValue: false,
  },
});

export default i18n;
